module.exports = __webpack_public_path__ + "static/media/coinbase.ed9a1f61.png";